import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';
import { PlSliderComponent } from '@app/components/pl-slider/pl-slider.component';

@NgModule({
  imports: [CommonModule, PlIconModule, PlSlicePipeModule, MatSliderModule, FormsModule],
  declarations: [PlSliderComponent],
  exports: [PlSliderComponent],
})
export class PlSliderModule {}
